import styled from 'styled-components';
import { Text } from '@perch-labs/shrike';

export const LineThrough = styled(Text).attrs({
  color: 'secondary',
})`
  text-decoration: line-through;
`;
